import { render, staticRenderFns } from "./tag-nav.vue?vue&type=template&id=69311688&scoped=true&"
import script from "./tag-nav.vue?vue&type=script&lang=js&"
export * from "./tag-nav.vue?vue&type=script&lang=js&"
import style0 from "./tag-nav.vue?vue&type=style&index=0&id=69311688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69311688",
  null
  
)

export default component.exports